import { connect } from 'react-redux'

import ContactsImportView from './view.jsx';
import { importContacts } from 'src/legacy/redux/actions/rolodex.jsx';

import { updateContactList } from 'src/legacy/redux/actions/contactList.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {

  var id = ownProps.contactListId;
  var contactList = state.legacyRootReducer.contactLists.contactList[id];
  
  return {
    user: state.users.me,
    contactList: contactList && contactList.item ? contactList.item : null
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    importContacts: (contacts) => {
      return dispatch(importContacts(contacts));
    },

    updateContactList: (id, contact) => {
      return dispatch(updateContactList(id, contact));
    } 
  }
}

const ContactsImportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactsImportView)

export default withUseHooks(ContactsImportContainer);